import { useState as s, useCallback as o, useEffect as c } from "react";
import { mediaBreakpoints as m } from "../constants/media-breakpoints.js";
const u = (t) => {
  const e = m[t];
  return typeof e == "string" ? `(min-width: ${e})` : "max" in e ? `(max-width: ${e.max})` : "raw" in e ? e.raw : "";
}, d = (t) => {
  const e = typeof window < "u" ? window.matchMedia(u(t)) : null, [a, n] = s((e == null ? void 0 : e.matches) ?? !1), r = o((i) => {
    n(i.matches);
  }, []);
  return c(() => {
    if (e)
      return n(e.matches), e.addEventListener("change", r), () => e.removeEventListener("change", r);
  }, [t]), a;
};
export {
  d as useMediaQuery
};
